import * as React from "react"
import { type LucideIcon } from "lucide-react"
import { cn } from "@/lib/utils"

export interface EmptyStateProps extends React.HTMLAttributes<HTMLDivElement> {
  icon?: LucideIcon
  title?: string
  description?: string
  action?: React.ReactNode
  size?: "sm" | "md" | "lg"
}

const EmptyState = React.forwardRef<HTMLDivElement, EmptyStateProps>(
  ({
    className,
    icon: Icon,
    title,
    description,
    action,
    size = "md",
    ...props
  }, ref) => {
    const sizeClasses = {
      sm: "py-8",
      md: "py-12",
      lg: "py-16"
    }

    const iconSizes = {
      sm: 32,
      md: 48,
      lg: 64
    }

    return (
      <div
        ref={ref}
        className={cn(
          "flex flex-col items-center justify-center text-center",
          sizeClasses[size],
          className
        )}
        {...props}
      >
        {Icon && (
          <Icon
            className="text-muted-foreground mb-4"
            size={iconSizes[size]}
          />
        )}

        {title && (
          <h3 className="text-lg font-semibold text-foreground mb-2">
            {title}
          </h3>
        )}

        {description && (
          <p className="text-sm text-muted-foreground mb-6 max-w-sm">
            {description}
          </p>
        )}

        {action && (
          <div className="flex items-center justify-center">
            {action}
          </div>
        )}
      </div>
    )
  }
)

EmptyState.displayName = "EmptyState"

export { EmptyState }
